'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generateChangeProviderApplication = generateChangeProviderApplication;

require('regenerator-runtime/runtime');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _reactRouterRedux = require('react-router-redux');

var _changeProviderSagas = require('./changeProviderSagas.js');

var _changeProviderSagas2 = _interopRequireDefault(_changeProviderSagas);

var _reduxSaga = require('redux-saga');

var _reduxSaga2 = _interopRequireDefault(_reduxSaga);

var _redux = require('redux');

var _reduxDevtoolsExtension = require('redux-devtools-extension');

var _ChangeProviderHelp = require('./components/ChangeProviderHelp');

var _ChangeProviderHelp2 = _interopRequireDefault(_ChangeProviderHelp);

var _ChangeProviderIndex = require('./components/ChangeProviderIndex.js');

var _ChangeProviderIndex2 = _interopRequireDefault(_ChangeProviderIndex);

var _ChangeProviderLearnMore = require('./components/ChangeProviderLearnMore.js');

var _ChangeProviderLearnMore2 = _interopRequireDefault(_ChangeProviderLearnMore);

var _ChangeProviderCompare = require('./components/ChangeProviderCompare.js');

var _ChangeProviderCompare2 = _interopRequireDefault(_ChangeProviderCompare);

var _ChangeProviderReducer = require('./ChangeProviderReducer.js');

var _ChangeProviderReducer2 = _interopRequireDefault(_ChangeProviderReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable react/prop-types */
function generateChangeProviderApplication(_ref) {
  var initialState = _ref.initialState,
      shouldDebug = _ref.shouldDebug,
      history = _ref.history,
      middleware = _ref.middleware,
      providerApi = _ref.providerApi,
      WixStoreApi = _ref.WixStoreApi,
      controllerCreator = _ref.controllerCreator;

  var sagaMiddleware = (0, _reduxSaga2.default)();
  var routerHistoryMiddleware = (0, _reactRouterRedux.routerMiddleware)(history);
  var realControllerCreator = controllerCreator || function (controller) {
    return controller;
  };
  var composer = shouldDebug ? (0, _reduxDevtoolsExtension.composeWithDevTools)({ name: 'Art Store - Change provider' }) : _redux.compose;

  var store = (0, _redux.createStore)(_ChangeProviderReducer2.default, initialState, composer((0, _redux.applyMiddleware)(middleware, sagaMiddleware, routerHistoryMiddleware)));
  sagaMiddleware.run((0, _changeProviderSagas2.default)(WixStoreApi, providerApi));

  return _react2.default.createElement(
    _reactRedux.Provider,
    { store: store },
    _react2.default.createElement(
      _reactRouter.Router,
      { history: history },
      _react2.default.createElement(
        _reactRouter.Route,
        {
          path: '/',
          component: function component(props) {
            return _react2.default.createElement(
              'div',
              null,
              props.children,
              _react2.default.createElement(_ChangeProviderHelp2.default, null)
            );
          }
        },
        _react2.default.createElement(_reactRouter.IndexRoute, { component: realControllerCreator(_ChangeProviderIndex2.default) }),
        _react2.default.createElement(_reactRouter.Route, {
          path: '/learnmore/:providerId',
          component: realControllerCreator(_ChangeProviderLearnMore2.default)
        }),
        _react2.default.createElement(_reactRouter.Route, {
          path: '/compareProviders',
          component: realControllerCreator(_ChangeProviderCompare2.default)
        })
      )
    )
  );
}
/* eslint-enable react/prop-types */